module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/24.c3cf00e0.png";